import { createSlice } from '@reduxjs/toolkit';
// import { database } from 'faker/locale/en_AU';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  clients: null,
  cadences: null,
  createdClient: null,
  detailInfo: null,
  updateClient: null,
  scheduledPauses: null,
  clientEndpoints: null,
  createEndpoints: null,
  updateEndpoints: null,
  duplicateEndpoints: null,
  endpointMap: null,
  updateMap: null,
  clientTokens: null,
  createTokens: null,
  deleteTokens: null,
  updateTokens: null,
  clientIntegrationsEx: null,
  postBacks: null,
  createIntegrationsEx: null,
  deleteIntegrationsEx: null,
  updateIntegrationsEx: null,
  columns: null,
  data: null,
  leadSearchData: null,
  saveLeadData: null,
  fieldMappings:[],
  authenticationTypes:[],
  sendTypes:[],
  endPointTypes: [],
  lqclientproductlist:[],
  lqsaidlist:[],
  cadencenames:[],
  clientExceptions:[],
  createCadence: null,
  duplicateCadence: null,
  updateCadence: null,
  deleteCadences: null,
  createPhoneConf: null,
  updatePhoneConf: null,
  createSMSConf: null,
  updateSMSConf: null,
  createEmailConf: null,
  updateEmailConf: null,
  createTouchPoint: null,
  archiveCadences: null,
  createFolloup: null,
  createEndCadence: null,
  updateFolloup: null,
  deleteFolloup: null,
  deleteEndCadence: null,
  updateEndCadence: null,
  endMap : null,
  disposition: null,
  touchPoint: null,
  inbountTouch: null,
  leadData: null,
  options: null,
  bookings: [],
  endCadenceType: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    formatError(state, action) {
      state.error = false;
    },

    saveColumn(state, action) {
      state.isLoading = false;
      state.columns = action.payload;
    },

    saveData(state, action) {
        state.isLoading = false;
        state.data = action.payload;
    },

    saveLeadData(state, action) {
      state.isLoading = false;
      state.saveLeadData = action.payload;
    },

    getClient(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    getCadence(state, action) {
      state.isLoading = false;
      state.cadences = action.payload;
    },

    getLeadData(state, action) {
      state.isLoading = false;
      state.leadSearchData = action.payload;
    },

    //GET BOOKING LIST
    getBookingList(state, action) {
      state.isLoading = false;
      state.bookings = action.payload;
    },

    // GET PROFILE
    getClientIntegration(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    // GET PROFILE
    getExceptionsByClientID(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },
    // GET PROFILE
    clearExceptionsByClientId(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },

    // GET PROFILE
    getFieldMappings(state, action) {
      state.isLoading = false;
      state.fieldMappings = action.payload;
    },
    getLqClientProductList(state, action) {
      state.isLoading = false;
      state.lqclientproductlist = action.payload;
    },

    getSaidID(state, action) {
      state.isLoading = false;
      state.lqsaidlist = action.payload;
    },

    getCadenceNames(state, action) {
      state.isLoading = false;
      state.cadencenames = action.payload;
    },

    //CREACT CLIENTINTEGRATION ACCOUNT
    createClientIntegration(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },

    // TODO - finalize
    createClient(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },    

    createClientEndpoints(state, action) {
      state.isLoading = false;
      state.createEndpoints = action.payload;
    },

    createClientCadences(state, action) {
      state.isLoading = false;
      state.createCadence = action.payload;
    },

    createClientTouchPoint(state, action) {
      state.isLoading = false;
      state.createTouchPoint = action.payload;
    },

    createClientFollowUp(state, action) {
      state.isLoading = false;
      state.createFolloup = action.payload;
    },

    updateClientFollowUp(state, action) {
      state.isLoading = false;
      state.updateFolloup = action.payload;
    },

    createClientEndCadnece(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadnece(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },

    deleteClientEndCadence(state, action) {
      state.isLoading = false;
      state.deleteEndCadence = action.payload;
    },
    deleteClientFollowUp(state, action) {
      state.isLoading = false;
      state.deleteFolloup = action.payload;
    },
    
    createClientEndCadence(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadence(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },
    
    duplicateClientCadences(state, action) {
      state.isLoading = false;
      state.duplicateCadence = action.payload;
    },

    createdPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.createPhoneConf = action.payload;
    },

    createdEmailConfiguration(state, action) {
      state.isLoading = false;
      state.createEmailConf = action.payload;
    },

    createdSMSConfiguration(state, action) {
      state.isLoading = false;
      state.createSMSConf = action.payload;
    },

    updatedPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.updatePhoneConf = action.payload;
    },
    
    updatedSMSConfiguration(state, action) {
      state.isLoading = false;
      state.updateSMSConf = action.payload;
    },

    updatedEmailConfiguration(state, action) {
      state.isLoading = false;
      state.updateEmailConf = action.payload;
    },

    deleteClientCadences(state, action) {
      state.isLoading = false;
      state.deleteCadences = action.payload;
    },

    ArchiveClientCadences(state, action) {
      state.isLoading = false;
      state.archiveCadences = action.payload;
    },

    getScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },

    updateScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },    
    
    updateClientEndpoints(state, action) {
      state.isLoading = false;
      state.updateEndpoints = action.payload;
    },

    duplicateClientEndpoints(state, action) {
      state.isLoading = false;
      state.duplicateEndpoints = action.payload;
    },    

    updateClientCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },
    
    startCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    pauseCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientTokens(state, action) {
      state.isLoading = false;
      state.updateTokens = action.payload;
    },

    createClientTokens(state, action) {
      state.isLoading = false;
      state.createTokens = action.payload;
    },

    deleteClientTokens(state, action) {
      state.isLoading = false;
      state.deleteTokens = action.payload;
    },

    updateClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.updateIntegrationsEx = action.payload;
    },

    createClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.createIntegrationsEx = action.payload;
    },

    deleteClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.deleteIntegrationsEx = action.payload;
    },

    getDetailInfo(state, action) {
      state.isLoading = false;
      state.detailInfo = action.payload;
    },
    
    // TODO - Finalize
    updateClient(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    updateCadence(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientIntegration(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    getClientEndpoints (state, action) {
      state.isLoading = false;
      state.clientEndpoints = action.payload;
    },

    getClientTokens (state, action) {
      state.isLoading = false;
      state.clientTokens = action.payload;
    },

    getClientIntegrationsEx (state, action) {
      state.isLoading = false;
      state.clientIntegrationsEx = action.payload;
    },

    getPostBacks (state, action) {
      state.isLoading = false;
      state.postBacks = action.payload;
    },

    getEndpointMap (state, action) {
      state.isLoading = false;
      state.endpointMap = action.payload;
    },

    getAuthenticationType (state, action) {
      state.isLoading = false;
      state.authenticationTypes = action.payload;
    },

    getSendType (state, action) {
      state.isLoading = false;
      state.sendTypes = action.payload;
    },

    getEndpointType (state, action) {
      state.isLoading = false;
      state.endPointTypes = action.payload;
    },

    updateEndpointMap (state, action) {
      state.isLoading = false;
      state.updateMap = action.payload;
    },
    getEndPointMapping (state, action){
      state.isLoading = false;
      state.endMap = action.payload;
    },
    getFinalDisposition (state, action) {
      state.isLoading = false;
      state.disposition = action.payload;
    },
    getTouchPointOutcome (state, action) {
      state.isLoading = false;
      state.touchPoint = action.payload;
    },
    getInboundTouchpoint (state, action) {
      state.isLoading = false;
      state.inbountTouch = action.payload;
    },
    getIncludeLeadData (state, action) {
      state.isLoading = false;
      state.leadData = action.payload;
    },
    getSubAccount (state, action){
      state.isLoading = false;
      state.subAccountData = action.payload;
    },
    getOptions (state, action){
      state.isLoading = false;
      state.options = action.payload;
    },
    getEndCadenceType (state, action){
      state.isLoading = false;
      state.endCadenceType = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;


export function getCadences() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadence/management/list');
      dispatch(slice.actions.getCadence(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadencesEndpoint(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/cadence_endpoint', {lead_id: id});
      dispatch(slice.actions.getCadence(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function leadSearch(data, isLoading) {
  return async (dispatch) => {
    if(isLoading) {
      dispatch(slice.actions.startLoading());
    }
    try {
      const response = await axios.post('/iapi/cadence/management/leadSearch', data);
      dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadDetails(lead_id, isLoading) {
  return async (dispatch) => {
    if(isLoading) {
      dispatch(slice.actions.startLoading());
    }
    try {
      const response = await axios.get(`/iapi/cadence/management/lead/${lead_id}`);
      // dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getScheduledPauses(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const firstId = data.id.split(",")[0];
      const firstClientIntegrationId = data.client_integration_id.split(",")[0];
      const response = await axios.get('/iapi/cadence/admin/config/scheduledpause/' +
        firstId + "/" + firstClientIntegrationId, data);
      dispatch(slice.actions.getScheduledPauses(response.data));
      return response.data;;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateScheduledPauses(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const firstId = data.id.split(",")[0];
      const firstClientIntegrationId = data.client_integration_id.split(",")[0];
      const response = await axios.post('/iapi/cadence/admin/config/scheduledpause/' +
        firstId + "/" + firstClientIntegrationId, data);
      dispatch(slice.actions.updateScheduledPauses(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function startCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/start', data);
      dispatch(slice.actions.startCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function pauseCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/pause', data);
      dispatch(slice.actions.pauseCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function getLeadLists(cadence_id, filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/leads', {
          "cadence_id" : cadence_id,
          "filters" : filter
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPendingLeadLists(endpoint_id, filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/pendingLeads', {
          "endpoint_id" : endpoint_id,
          "filters" : filter
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
};

export function previousTouchpoints(lead_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/previoustouchpoints', {
          "lead_id" : lead_id,
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getLeadDetail(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/lead', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function pullLead(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/pull_lead', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function multi_pull_lead(ids) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/multi_pull_lead', {lead_ids: ids});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function moveToCadence(lead_id, cadence_id, old_cadence) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/move_to_cadence', {lead_id: lead_id, cadence_id: cadence_id, old_cadence: old_cadence});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTouchpoints(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/touchpoints', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadenceDetail(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/management/info/'+cadence_id);
      return response.data
    } catch (error) {
      return null
    }
  };
}

export function getCadenceStatus(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/cadence_status', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getTouchpointsInbound(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/touchpoints_inbound', {lead_id: id});
      let data  = response['data']
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPastCadence(cadence_id, lead_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/previous_cadence_summary', {cadence_id: cadence_id, lead_id: lead_id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function pauseUnpauseEndpoint(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/pauseUnpauseEndpoint', data);
      let res  = response.data
      return res;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
